import { createReducer } from 'redux-act';
import actions from '../actions/qualificationActions';

const initialState = {
    addQualificationPending: false,
    addQualificationRes: null,
    addQualificationError: null,

    getAllQualificationPending: false,
    getAllQualificationRes: null,
    getAllQualificationError: null,

    getAllQualificationsByParentIdPending: false,
    getAllQualificationsByParentIdRes: null,
    getAllQualificationsByParentIdError: null,

    updateQualificationPending: false,
    updateQualificationRes: null,
    updateQualificationError: null,

    deleteQualificationPending: false,
    deleteQualificationRes: null,
    deleteQualificationError: null,
};
/* Add Qualification Reducers */
const handleAddQualificationRequest = state => {
    return {
        ...state,
        ...{
            addQualificationPending: true,
            addQualificationRes: null,
            addQualificationError: null,
        },
    };
};
const handleAddQualificationSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addQualificationPending: false,
            addQualificationRes: payload,
            addQualificationError: null,
        },
    };
};
const handleAddQualificationError = (state, payload) => ({
    ...state,
    ...{
        addQualificationPending: false,
        addQualificationRes: null,
        addQualificationError: payload,
    },
});


/* Get All Qualification Reducers */
const handleGetAllQualificationRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllQualificationPending: true,
            getAllQualificationRes: null,
            getAllQualificationError: null,
        },
    };
};
const handleGetAllQualificationSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllQualificationPending: false,
            getAllQualificationRes: payload,
            getAllQualificationError: null,
        },
    };
};
const handleGetAllQualificationError = (state1, payload) => ({
    ...state1,
    ...{
        getAllQualificationPending: false,
        getAllQualificationRes: null,
        getAllQualificationError: payload,
    },
});

/* Get All Qualifications By Parent Id  Reducers */
const handleGetAllQualificationsByParentIdRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllQualificationsByParentIdPending: true,
            getAllQualificationsByParentIdRes: null,
            getAllQualificationsByParentIdError: null,
        },
    };
};
const handleGetAllQualificationsByParentIdSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllQualificationsByParentIdPending: false,
            getAllQualificationsByParentIdRes: payload,
            getAllQualificationsByParentIdError: null,
        },
    };
};
const handleGetAllQualificationsByParentIdError = (state1, payload) => ({
    ...state1,
    ...{
        getAllQualificationsByParentIdPending: false,
        getAllQualificationsByParentIdRes: null,
        getAllQualificationsByParentIdError: payload,
    },
});

/* Update Qualification Reducers */
const handleUpdateQualificationRequest = state1 => {
    return {
        ...state1,
        ...{
            updateQualificationPending: true,
            updateQualificationRes: null,
            updateQualificationError: null,
        },
    };
};
const handleUpdateQualificationSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateQualificationPending: false,
            updateQualificationRes: payload,
            updateQualificationError: null,
        },
    };
};
const handleUpdateQualificationError = (state1, payload) => ({
    ...state1,
    ...{
        updateQualificationPending: false,
        updateQualificationRes: null,
        updateQualificationError: payload,
    },
});

/* Delete Qualification Reducers */
const handleDeleteQualificationRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteQualificationPending: true,
            deleteQualificationRes: null,
            deleteQualificationError: null,
        },
    };
};
const handleDeleteQualificationSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteQualificationPending: false,
            deleteQualificationRes: payload,
            deleteQualificationError: null,
        },
    };
};
const handleDeleteQualificationError = (state1, payload) => ({
    ...state1,
    ...{
        deleteQualificationPending: false,
        deleteQualificationRes: null,
        deleteQualificationError: payload,
    },
});

/* clear Qualification Store */
const clearQualificationStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_ADD_QUALIFICATION_STORE':
            return {
                ...state,
                ...{
                    addQualificationPending: false,
                    addQualificationRes: null,
                    addQualificationError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_QUALIFICATION_STORE':
            return {
                ...state,
                ...{
                    updateQualificationPending: false,
                    updateQualificationRes: null,
                    updateQualificationError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_QUALIFICATION_STORE':
            return {
                ...state,
                ...{
                    deleteQualificationPending: false,
                    deleteQualificationRes: null,
                    deleteQualificationError: null,
                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.addQualificationRequest]: handleAddQualificationRequest,
        [actions.addQualificationSuccess]: handleAddQualificationSuccess,
        [actions.addQualificationError]: handleAddQualificationError,

        [actions.getAllQualificationRequest]: handleGetAllQualificationRequest,
        [actions.getAllQualificationSuccess]: handleGetAllQualificationSuccess,
        [actions.getAllQualificationError]: handleGetAllQualificationError,

        [actions.getAllQualificationsByParentIdRequest]: handleGetAllQualificationsByParentIdRequest,
        [actions.getAllQualificationsByParentIdSuccess]: handleGetAllQualificationsByParentIdSuccess,
        [actions.getAllQualificationsByParentIdError]: handleGetAllQualificationsByParentIdError,

        [actions.updateQualificationRequest]: handleUpdateQualificationRequest,
        [actions.updateQualificationSuccess]: handleUpdateQualificationSuccess,
        [actions.updateQualificationError]: handleUpdateQualificationError,

        [actions.deleteQualificationRequest]: handleDeleteQualificationRequest,
        [actions.deleteQualificationSuccess]: handleDeleteQualificationSuccess,
        [actions.deleteQualificationError]: handleDeleteQualificationError,

        [actions.handleClearQualificationStore]: clearQualificationStore,
    },
    initialState,
);